module.exports = __webpack_public_path__ + "img/dolchdynamite.cf0b4048.png";